<template>
    <div class="container pt-lg-md register-component">
        <div class="row justify-content-center">
            <div class="col-lg-5">
                <card shadow
                      header-classes="bg-white pb-5"
                      body-classes="px-lg-5 py-lg-5"
                      class="border-0">
                    <i @click="lambdaClose()" v-if="close"
                       style="position: absolute; top: 15px; right: 15px; font-weight: 100"
                       class="fa fa-close display-4"></i>
                    <template v-if="authenticate && mode === FORGET">
                        <div class="text-muted mb-4">
                            <h6 class="font-weight-bold">{{language.lang("FORGET PASSWORD")}}</h6>
                            <span>{{language.lang("Enter your email address to receive the new temporary password")}}</span>
                        </div>
                        <form role="form" class="mt-3">
                            <base-input alternative
                                        class="mb-3"
                                        type="email"
                                        v-model="email"
                                        :placeholder="language.lang('Your Email address')"
                                        addon-left-icon="fa fa-envelope">
                            </base-input>
                        </form>
                        <form role="form" class="mt-3">
                            <div class="text-center mt-5">
                                <base-button @click="forgetPassword" text-color="white"
                                             type="default" class="btn-custom-setting">
                                    {{language.lang("Reset password")}}
                                </base-button>
                                <base-button @click="login"
                                             type="secondary" class="btn-custom-setting">
                                    {{language.lang("Discard")}}
                                </base-button>
                            </div>
                        </form>
                    </template>
                    <template v-else-if="authenticate && currentPath != null && currentPath.endsWith('register')">
                        <div class="text-muted">
                            <h6 class="font-weight-bold">{{language.lang("Create an Account")}}</h6>
                            <span>{{language.lang("Please fill in the form below and we will contact you via email once we process your sign up application.")}}</span>
                        </div>
                        <form role="form" class="mt-3">
                            <base-input v-model="username" alternative
                                        class="mb-3"
                                        :placeholder="language.lang('Account username')"
                                        addon-left-icon="fa fa-user-circle">
                            </base-input>
                            <base-input alternative
                                        class="mb-3"
                                        type="password"
                                        v-model="password"
                                        :placeholder="language.lang('Case sensitive password')"
                                        addon-left-icon="fa fa-lock">
                            </base-input>
                            <base-input alternative
                                        class="mb-3"
                                        type="password"
                                        v-model="passwordRetry"
                                        :placeholder="language.lang('Type your password again')"
                                        addon-left-icon="fa fa-lock">
                            </base-input>
                            <base-input alternative
                                        class="mb-3 "
                                        v-model="fullName"
                                        :placeholder="language.lang('Your Full name')"
                                        addon-left-icon="fa fa-user">
                            </base-input>
                            <base-input alternative
                                        class="mb-3"
                                        type="tel"
                                        v-model="mobileLogin"
                                        :placeholder="language.lang('Your Phone number')"
                                        addon-left-icon="fa fa-phone">
                            </base-input>
                            <base-input alternative
                                        class="mb-3"
                                        type="email"
                                        v-model="email"
                                        :placeholder="language.lang('Your Email address')"
                                        addon-left-icon="fa fa-envelope">
                            </base-input>
                            <base-input alternative
                                        class="mb-3"
                                        v-model="licenseID"
                                        :placeholder="language.lang('Your Licence ID')"
                                        addon-left-icon="fa fa-id-card">
                            </base-input>
                            <base-input alternative
                                        class="mb-3"
                                        v-model="officeAddress"
                                        :placeholder="language.lang('Your Office Address')"
                                        addon-left-icon="fa fa-address-book">
                            </base-input>
                            <base-checkbox v-model="rulesCheckBox" class="text-left">
                                    <span v-if="isEN"> {{language.lang("I agree with the")}}
                                        <router-link class="font-weight-bold"
                                                     to="/accounts/rules">{{language.lang("rules and agreements")}}</router-link>
                                    </span>
                                <span v-else>
                                        <router-link class="font-weight-bold"
                                                     to="/accounts/rules">{{language.lang("rules and agreements")}}</router-link>
                                    {{language.lang("I agree with the")}}
                                    </span>
                            </base-checkbox>
                            <div class="text-center mt-5">
                                <base-button @click="submitSignUp" text-color="white"
                                             type="default" class="btn-custom-setting">
                                    {{language.lang("Sign up")}}
                                </base-button>
                                <base-button @click="$router.push('/accounts/login')" text-color="white"
                                             type="primary" class="btn-custom-setting">
                                    {{language.lang("I have an account")}}
                                </base-button>
                            </div>
                        </form>
                    </template>
                    <template v-else-if="authenticate">
                        <div class="text-muted">
                            <h6 class="font-weight-bold">{{language.lang("SIGN IN TO YOUR ACCOUNT")}}</h6>
                            <span>{{language.lang("Enter your username and password to log into your account.")}}</span>
                        </div>
                        <form role="form" class="mt-3">
                            <base-input v-model="username" alternative
                                        class="mb-3"
                                        :placeholder="language.lang('Account username')"
                                        addon-left-icon="fa fa-user-circle">
                            </base-input>
                            <base-input alternative
                                        class="mb-3"
                                        type="password"
                                        v-model="password"
                                        :placeholder="language.lang('Case sensitive password')"
                                        addon-left-icon="fa fa-lock">
                            </base-input>
                            <div class="text-center mt-5">
                                <base-button @click="submitSign" text-color="white"
                                             type="default" class="btn-custom-setting">
                                    {{language.lang("Sign In")}}
                                </base-button>
                                <base-button @click="$router.push('/accounts/register')" text-color="white"
                                             type="primary" class="btn-custom-setting">
                                    {{language.lang("I dont have an account yet!")}}
                                </base-button>
                            </div>
                        </form>
                    </template>
                    <template v-else-if="mode === RESET">
                        <div class="text-muted">
                            <h6 class="font-weight-bold">{{language.lang("RESET PASSWORD")}}</h6>
                            <span>{{language.lang("Enter your new password and confirm it.")}}</span>
                        </div>
                        <form role="form" class="mt-3">
                            <base-input alternative
                                        class="mb-3"
                                        type="password"
                                        v-model="password"
                                        :placeholder="language.lang('Case sensitive password')"
                                        addon-left-icon="fa fa-lock">
                            </base-input>
                            <base-input alternative
                                        class="mb-3"
                                        type="password"
                                        v-model="passwordRetry"
                                        :placeholder="language.lang('Type your password again')"
                                        addon-left-icon="fa fa-lock">
                            </base-input>
                            <div class="text-center mt-5">
                                <base-button @click="submitPassword" text-color="white"
                                             type="default" class="btn-custom-setting">
                                    {{language.lang("Change password")}}
                                </base-button>
                            </div>
                        </form>
                    </template>
                    <template v-else-if="mode === REGISTER">
                        <div class="text-muted">
                            <h6 class="font-weight-bold">{{language.lang("REGISTER")}}</h6>
                            <span>{{language.lang("Enter your name and phone number or email address to register, If you already registered log in")}}</span>
                        </div>
                        <v-tabs :show-arrows="false" class="mt-3 mb-3" v-model="tab" align-with-title grow>
                            <v-tabs-slider></v-tabs-slider>
                            <v-tab v-for="item in items" :key="item">
                                {{ item }}
                            </v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="tab">
                            <v-tab-item style="width: 100%; background-color: transparent" v-for="(item,index) in items"
                                        :key="index">
                                <form role="form">
                                    <base-input v-model="fullName" alternative
                                                class="mb-3"
                                                :placeholder="language.lang('First name and last name')"
                                                addon-left-icon="fa fa-user-circle">
                                    </base-input>
                                    <base-input alternative v-if="index == 0"
                                                class="mb-3"
                                                type="email"
                                                v-model="emailLogin"
                                                :placeholder="language.lang('Email Address')"
                                                addon-left-icon="fa fa-envelope">
                                    </base-input>
                                    <base-input alternative v-else
                                                class="mb-3"
                                                type="tel"
                                                v-model="mobileLogin"
                                                :placeholder="language.lang('Phone number')"
                                                addon-left-icon="ni ni-mobile-button">
                                    </base-input>
                                    <base-input alternative
                                                class="mb-3"
                                                type="password"
                                                v-model="password"
                                                :placeholder="language.lang('Case sensitive password')"
                                                addon-left-icon="fa fa-lock">
                                    </base-input>
                                </form>
                            </v-tab-item>
                        </v-tabs-items>
                        <form role="form">
                            <base-checkbox v-model="rulesCheckBox" class="text-left">
                                    <span v-if="isEN"> {{language.lang("I agree with the")}}
                                        <router-link class="font-weight-bold"
                                                     to="/rules">{{language.lang("rules and agreements")}}</router-link>
                                    </span>
                                <span v-else>
                                    <router-link class="font-weight-bold"
                                                 to="/rules">{{language.lang("rules and agreements")}}</router-link>
                                     {{language.lang("I agree with the")}}
                                    </span>
                            </base-checkbox>
                            <div class="text-center mt-5">
                                <base-button @click="submitRegister" text-color="white"
                                             type="default" class="btn-custom-setting">
                                    {{language.lang("Get Connected")}}
                                </base-button>
                                <base-button @click="login" text-color="white"
                                             type="primary" class="btn-custom-setting">
                                    {{language.lang("I already have an account")}}
                                </base-button>
                            </div>
                        </form>
                    </template>
                    <template v-else-if="mode === LOGIN">
                        <div class="text-muted mb-4">
                            <h6 class="font-weight-bold">{{language.lang("LOGIN")}}</h6>
                            <span>{{language.lang("Enter your mobile number or email address to receive the confirmation code")}}</span>
                        </div>
                        <v-tabs :show-arrows="false" class="mt-3 mb-3" v-model="tab" align-with-title grow>
                            <v-tabs-slider></v-tabs-slider>
                            <v-tab v-for="item in items" :key="item">
                                {{ item }}
                            </v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="tab">
                            <v-tab-item style="width: 100%; background-color: transparent" v-for="(item,index) in items"
                                        :key="index">
                                <form role="form" class="mt-3">
                                    <base-input alternative v-if="index == 0"
                                                class="mb-3"
                                                v-model="emailLogin"
                                                type="email"
                                                :placeholder="language.lang('Email Address')"
                                                addon-left-icon="fa fa-envelope">
                                    </base-input>
                                    <base-input alternative v-else
                                                class="mb-3"
                                                v-model="mobileLogin"
                                                type="tel"
                                                :placeholder="language.lang('Phone number')"
                                                addon-left-icon="ni ni-mobile-button">
                                    </base-input>
                                    <base-input alternative :disabled="!showPassword"
                                                class="mb-3" :style="showPassword?'opacity: 1':'opacity: 0'"
                                                type="password"
                                                v-model="password"
                                                :placeholder="language.lang('Case sensitive password')"
                                                addon-left-icon="fa fa-lock">
                                    </base-input>
                                </form>
                            </v-tab-item>
                        </v-tabs-items>
                        <form role="form">
                            <div role="button" :style="showPassword ? 'opacity: 1':'opacity: 0'"
                                 @click="showPassword = false"
                                 style="height: auto; color: #aaa">
                                <i style="font-size: 11px" class="fa fa-circle-o ml-2"></i>
                                <span style="font-size: 13px" class="font-weight-bold">
                                    {{language.lang(showPassword ? "Forget your password?" : "Login with password")}}
                        <span style="font-size: 14px; color: #00aff0 !important;"
                              class="ml-2 mr-2 font-weight-bold text-underline">{{language.lang("Click here")}}</span></span>
                            </div>
                            <div class="text-center mt-5">
                                <base-button @click="submitLogin" text-color="white"
                                             type="default" class="btn-custom-setting">
                                    {{language.lang(showPassword ? "Login to account" : "Request password reset")}}
                                </base-button>
                                <base-button v-if="!showPassword" @click="showPassword = true"
                                             text-color="white"
                                             type="primary" class="btn-custom-setting">
                                    {{language.lang("Login with password")}}
                                </base-button>
                                <base-button v-else @click="register" text-color="white"
                                             type="primary" class="btn-custom-setting">
                                    {{language.lang("I do not have an account")}}
                                </base-button>
                            </div>
                        </form>
                    </template>
                    <template v-else-if="mode === VERIFY">
                        <div class="text-muted mb-4">
                            <div class="titleLogin">
                                <h6 class="font-weight-bold">{{language.lang("CONFIRMATION")}}</h6>
                                <span>
                        {{language.lang("Enter the code sent to your mobile number or email address")}}
                        </span>
                            </div>
                        </div>
                        <form role="form" class="mt-3">
                            <base-input alternative
                                        class="mb-3 font-weight-bold"
                                        type="tel"
                                        v-model="codeConfirm"
                                        placeholder="-   -   -   -"
                                        addon-left-icon="fa fa-shield">
                            </base-input>
                            <div class="text-center mt-5">
                                <base-button @click="submitConfirm" text-color="white"
                                             type="default" class="btn-custom-setting">
                                    {{language.lang("finalizing")}}
                                </base-button>
                                <base-button type="secondary" class="btn-custom-setting" @click="resentCode">
                                    {{ countDown > 0 ? oracle.formatMinutes(countDown) + language.lang(" Seconds to resend") :
                                    language.lang("Resend the code")}}
                                </base-button>
                            </div>
                        </form>
                    </template>
                </card>
                <div role="button" @click="$router.push('/accounts/login')"
                     class="p-2 border-bottom"
                     style="height: auto; background-color: #ffffff; color: #aaa"
                     v-if="!authenticate">
                    <i style="font-size: 11px" class="fa fa-circle-o ml-2 mr-2"></i>
                    <span style="font-size: 13px" class="font-weight-bold">{{language.lang("Are you a consultant?")}}
                        <span style="font-size: 14px; color: #00aff0 !important;"
                              class="ml-2 mr-2 font-weight-bold text-underline">{{language.lang("Click here")}}</span></span>
                </div>
                <div role="button" @click="forget" class="p-2 border-bottom"
                     style="height: auto; background-color: #ffffff; color: #aaa"
                     v-else-if="authenticate && currentPath != null && !currentPath.endsWith('register') && mode != FORGET">
                    <i style="font-size: 11px" class="fa fa-circle-o ml-2 mr-2"></i>
                    <span style="font-size: 13px" class="font-weight-bold">{{language.lang("Forget your password?")}}
                        <span style="font-size: 14px; color: #00aff0 !important;"
                              class="ml-2 mr-2 font-weight-bold text-underline">{{language.lang("Click here")}}</span></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import oracle from "@/utils/oracle";
  import language from "@/utils/language";
  import Form from "@/views/Form";

  const MOBILE = 1;
  const EMAIL = 0;

  const REGISTER = "register";
  const VERIFY = "verify";
  const FORGET = "forget";
  const LOGIN = "login";
  const RESET = "reset";

  export default {
    name: "RegisterComponent",
    components: { Form },
    props: {
      lambdaDone: null,
      lambdaClose: null,
      close: false,
      hint: "",
      authenticate: false
    },
    data: () => ({
      MOBILE: MOBILE,
      EMAIL: EMAIL,
      REGISTER: REGISTER,
      VERIFY: VERIFY,
      FORGET: FORGET,
      LOGIN: LOGIN,
      RESET: RESET,
      oracle: oracle,
      tab: null,
      currentPath: "",
      showPassword: true,
      rulesCheckBox: false,
      username: null,
      password: null,
      mobileLogin: null,
      emailLogin: null,
      email: null,
      licenseID: null,
      officeAddress: null,
      mode: REGISTER,
      fullName: null,
      isEN: oracle.isEN(),
      passwordRetry: null,
      lastMode: "",
      codeConfirm: null,
      countDown: 60 * 5,
      language: language,
      items: [
        language.lang("Email Address"), language.lang("Phone Number")
      ]
    }),
    methods: {
      submitSignUp() {
        if (!this.rulesCheckBox) {
          let message = this.language.lang("Please read and sign rules and agreements");
          oracle.showMessage(message);
          return;
        }
        if (!oracle.isEmail(this.email)) {
          let message = this.language.lang("Enter your valid email address");
          oracle.showMessage(message);
        } else if (this.username == null || this.username.length == 0) {
          let message = this.language.lang("Username can not be empty");
          oracle.showMessage(message);
        } else if (this.password == null || this.password.length == 0) {
          let message = this.language.lang("Password can not be empty");
          oracle.showMessage(message);
        } else if (this.password != this.passwordRetry) {
          let message = this.language.lang("Passwords do not match");
          oracle.showMessage(message);
        } else if (this.mobileLogin == null) {
          let message = this.language.lang("Enter your mobile number in correct digits");
          oracle.showMessage(message);
        } else {
          oracle.axios(
            "lawyer/register",
            {
              password: oracle.MD5(this.password)
              , username: this.username
              , lawyer_brief: this.licenseID
              , lawyer_title: this.fullName
              , lawyer_email: this.email
              , lawyer_phone: this.mobileLogin
              , lawyer_location_canada: this.officeAddress
            },
            ((res) => {
              oracle.setLawyer(true);
              this.$root.$emit("islogin");
              if (this.lambdaDone != null)
                this.lambdaDone();
            })
          );
        }
      },
      submitSign() {
        if (this.username == null || this.username.length == 0) {
          let message = this.language.lang("Username can not be empty");
          oracle.showMessage(message);
        } else if (this.password == null || this.password.length == 0) {
          let message = this.language.lang("Password can not be empty");
          oracle.showMessage(message);
        } else {
          oracle.axios(
            "lawyer/login",
            { password: oracle.MD5(this.password), username: this.username },
            ((res) => {
              oracle.setLawyer(true);
              this.$root.$emit("islogin");
              if (this.lambdaDone != null)
                this.lambdaDone();
            })
          );
        }
      }, register() {
        if (this.mode != VERIFY) this.lastMode = this.mode;
        this.mode = REGISTER;
      }, login() {
        if (this.mode != VERIFY) this.lastMode = this.mode;
        this.mode = LOGIN;
      }, forget() {
        if (this.mode != VERIFY) this.lastMode = this.mode;
        this.mode = FORGET;
      }, verify(res) {
        if (this.mode != VERIFY) this.lastMode = this.mode;
        this.mode = VERIFY;
        this.startCountDown();
        this.codeConfirm = res.data.captcha;
      }, reset() {
        if (this.mode != VERIFY) this.lastMode = this.mode;
        this.mode = RESET;
      }, submitRegister() {
        if (!this.rulesCheckBox) {
          let message = this.language.lang("Please read and sign rules and agreements");
          oracle.showMessage(message);
          return;
        }
        if (this.fullName == null || this.fullName.length < 4) {
          let message = this.language.lang("The minimum first and last name is 4 letters");
          oracle.showMessage(message);
        } else if (this.tab == MOBILE && (this.mobileLogin == null || this.mobileLogin.length < 11)) {
          let message = this.language.lang("Enter your mobile number in 11 digits");
          oracle.showMessage(message);
        } else if (this.tab == EMAIL && (this.emailLogin == null || this.emailLogin.length == 0)) {
          let message = this.language.lang("Enter your valid email address");
          oracle.showMessage(message);
        } else if (this.password == null || this.password.length == 0) {
          let message = this.language.lang("Password can not be empty");
          oracle.showMessage(message);
        } else {
          oracle.axios(
            "user/register",
            this.tab == MOBILE ? {
                phone: this.mobileLogin,
                username: this.fullName,
                password: oracle.MD5(this.password)
              }
              : { email: this.emailLogin, username: this.fullName, password: oracle.MD5(this.password) },
            ((res) => {
              this.verify(res);
            })
          );
        }
      },
      startCountDown() {
        this.disabled = true;
        this.countDown = 60 * 5;
        this.countDownTimer();
      }, submitConfirm() {
        oracle.axios(
          "user/verify",
          this.tab == MOBILE ? { captcha: this.codeConfirm, phone: this.mobileLogin } : {
            captcha: this.codeConfirm,
            email: this.emailLogin
          },
          ((res) => {
            this.submitUser(res);
          })
        );
      }, forgetPassword() {
        if (!oracle.isEmail(this.email)) {
          let message = this.language.lang("Enter your valid email address");
          oracle.showMessage(message);
        } else {
          oracle.axios(
            "lawyer/resetPassword",
            { email: this.email },
            ((res) => {
              this.login();
              oracle.showMessage(language.lang("Confirmation password has been sent successfully"), null, null, "checked");
            })
          );
        }
      },
      submitLogin() {
        if (this.tab == MOBILE && (this.mobileLogin == null || this.mobileLogin.length < 11)) {
          let message = this.language.lang("Enter your mobile number in 11 digits");
          oracle.showMessage(message);
        } else if (this.tab == EMAIL && (this.emailLogin == null || this.emailLogin.length == 0)) {
          let message = this.language.lang("Enter your valid email address");
          oracle.showMessage(message);
        } else if (this.showPassword && (this.password == null || this.password.length == 0)) {
          let message = this.language.lang("Password can not be empty");
          oracle.showMessage(message);
        } else {
          oracle.axios(
            "user/login",
            this.tab == MOBILE ? {
              phone: this.mobileLogin,
              password: this.showPassword ? oracle.MD5(this.password) : null
            } : { email: this.emailLogin, password: this.showPassword ? oracle.MD5(this.password) : null },
            ((res) => {
              if (!this.showPassword) {
                this.verify(res);
              } else {
                this.submitUser(res);
              }
            })
          );
        }
      }, submitUser(res) {
        oracle.setLawyer(false);
        let forms = oracle.getUnregisteredForms();
        if (forms != null && forms.length > 0) {
          oracle.axios("consult/updateForm", { "ids": forms }, (response) => {
            oracle.removeForms();
          });
        }
        this.$root.$emit("islogin");
        if (!this.showPassword && this.lastMode == LOGIN) {
          this.reset();
          return;
        }
        if (this.lambdaDone != null)
          this.lambdaDone();
      }, countDownTimer() {
        let refreshId = setInterval(() => {
          if (this.countDown > 0) {
            this.countDown -= 1;
          } else if (this.countDown == 0) {
            this.disabled = false;
            clearInterval(refreshId);
          }
        }, 1000);
      }, resentCode() {
        if (this.disabled == true) {
          return;
        }
        if (this.lastMode === "login") {
          this.submitLogin();
        } else {
          this.submitRegister();
        }
        this.startCountDown();
      }, submitPassword() {
        if (this.password == null || this.password.length == 0) {
          let message = this.language.lang("Password can not be empty");
          oracle.showMessage(message);
        } else if (this.password != this.passwordRetry) {
          let message = this.language.lang("Passwords do not match");
          oracle.showMessage(message);
        } else {
          oracle.axios("user/edit", { password: oracle.MD5(this.password) }, (res) => {
            oracle.showMessage(res.message, null, null, "checked");
            if (this.lambdaDone != null)
              this.lambdaDone();
          });
        }
      }
    },
    mounted() {
      this.currentPath = document.location.href;
      if (this.$router.currentRoute.fullPath.endsWith("login")) {
        this.mode = LOGIN;
      }
    }
  };
</script>

<style>
    .btn-custom-setting {
        margin: 0 0 1rem !important;
        width: 80%;
    }

    .register-component .theme--light.v-tabs > .v-tabs-bar {
        background-color: transparent;
    }

    .register-component .theme--light.v-tabs-items {
        background-color: transparent;
    }
</style>